var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-in"},[(_vm.page.title!='')?_c('div',{staticClass:"page_title title_h1 yo-color-primary",domProps:{"innerHTML":_vm._s(_vm.page.title)},on:{"click":function($event){if(!$event.ctrlKey)return null;return _vm.editNow.apply(null, arguments)}}}):_vm._e(),_c('div',{attrs:{"id":"page"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }